import React from 'react';

export const MarkerBuilding = () => (
  <>
    <g opacity="0.25" strokeWidth="0.02777778" transform="scale(36)">
      <path
        d="M 15,30 C 23.284,30 30,23.284 30,15 30,6.716 23.284,0 15,0 6.716,0 0,6.716 0,15 0,23.284 6.716,30 15,30 Z"
        fill="#182b4a"
        strokeWidth="0.02777778"
      />
    </g>
    <path
      fill="#182b4a"
      strokeWidth="1.00000012"
      d="M 540,918 C 748.764,918 918,748.764 918,540 918,331.236 748.764,162 540,162 331.236,162 162,331.236 162,540 c 0,208.764 169.236,378 378,378 z"
    />
    <path
      fill="#ffffff"
      strokeWidth="1.00000012"
      d="m 540,702 a 162,162 0 1 0 0,-324 162,162 0 0 0 0,324 z"
    />
  </>
);
